import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import { cx } from 'class-variance-authority'
import { isString } from 'lodash'
import type { ReactNode } from 'react'

export type TooltipProps = {
    trigger: ReactNode
    content: ReactNode
    isActive?: boolean
}

const Tooltip = ({ trigger, content, isActive = true }: TooltipProps) => {
    return (
        <TooltipPrimitive.Provider delayDuration={150}>
            <TooltipPrimitive.Root>
                <TooltipPrimitive.Trigger asChild>
                    {isString(trigger) ? (
                        <span className={cx(isActive && 'underline decoration-dotted underline-offset-2')}>
                            {trigger}
                        </span>
                    ) : (
                        trigger
                    )}
                </TooltipPrimitive.Trigger>
                <TooltipPrimitive.Portal>
                    {isActive && (
                        <TooltipPrimitive.Content
                            sideOffset={4}
                            className="leading-5 wrap-break-word bg-backgroundNeutralStrong bg-opacity-90 text-white text-sm p-3 rounded-2 shadow-lg max-w-125"
                        >
                            {content}
                        </TooltipPrimitive.Content>
                    )}
                </TooltipPrimitive.Portal>
            </TooltipPrimitive.Root>
        </TooltipPrimitive.Provider>
    )
}

export default Tooltip
